import React, {FC, useState} from "react";
import {FieldType} from "../../common/constants";
import {FilterInterceptor} from "../../shared/utilities/Filters/FilterInterceptor";
import FilterSortHeader from "./FilterSortHeader";

export interface ColumnConfig {
    id?: number;
    header: string | JSX.Element;
    width?: string;
    isLink?: boolean;
    filter?: boolean;
    sort?: boolean;
    style?: object;
    type?: FieldType;
    options?: any;
    filterField?: string;
}

interface ColumnHandlerProps {
    col: ColumnConfig;
    filterInterceptor: FilterInterceptor;
    setFilterConfig: (val: any) => void;
    setSortConfig?: (val: any) => void;
}

const ColumnHandler: FC<ColumnHandlerProps> = ({col, filterInterceptor, setFilterConfig, setSortConfig}) => {
    const [isFilterInputVisible, setIsFilterInputVisible] = useState(false);
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const handleSortUpClick = () => { /* Ваш код сортировки по возрастанию */
    };
    const handleSortDownClick = () => { /* Ваш код сортировки по убыванию */
    };
    const handleFilterClick = () => {
        updateFilterState(true);
    };
    const handleCloseFilter = () => {
        updateFilterState(false);
    };

    const setNewFilterValue = (val: any, modal: boolean) => {
        console.log("val", val)
        if (val && typeof val === 'object') {
            const columnHeader = Object.keys(val)[0];
            const columnValue = val[columnHeader].trim();
            if (columnValue === "") {
                const filterField = col.filterField ? col.filterField : (typeof col.header === "string" ? col.header : undefined);

                if (filterField) {
                    filterInterceptor.removeFilter(filterField);
                    updateImageFilterState(false);
                }
            } else {
                if (modal) {
                    const textFilterConfig = {
                        name: columnHeader,
                        typeField: col.type,
                        label: columnHeader,
                        value: columnValue,
                        options: col.options,
                        updateFunc: setNewFilterValue,
                    };
                    filterInterceptor.addFilter(textFilterConfig);
                    updateFilterState(false);
                    updateImageFilterState(true);
                }
            }
            filterInterceptor.updateFilterValue(columnHeader, columnValue);
            setFilterConfig(val);
        }
    };

    const updateFilterState = (isOpen: boolean) => {
        setIsFilterOpen(isOpen);
    };

    const updateImageFilterState = (isOpen: boolean) => {
        setIsFilterInputVisible(isOpen);
    };

    return (
        <FilterSortHeader
            headerText={typeof col.header === "string" ? col.header : ""}
            filterName={col.filterField ? col.filterField : typeof col.header === "string" ? col.header : ""}
            onFilterClick={handleFilterClick}
            onSortUpClick={handleSortUpClick}
            onSortDownClick={handleSortDownClick}
            onSortChange={setSortConfig}
            isFilterActive={isFilterInputVisible}
            isFilterOpen={isFilterOpen}
            setFilterModalClose={handleCloseFilter}
            setNewFilterValue={setNewFilterValue}
            fieldType={col.type}
            options={col.options}
            isSortingVisible={col.sort}
            isFilterVisible={col.filter}
        />
    );
};

export default ColumnHandler;
